class RouteMonitor {
  getCurrentRoute() {
    return this.getHttp().currentRoute;
  }

  getPreviousRoute() {
    return this.getHttp().previousRoute;
  }

  getReferrer() {
    return this.getHttp().referrer;
  }

  getOrigin() {
    return this.getHttp().origin;
  }

  getHttp() {
    return this.store.getState().http;
  }

  setStore(store) {
    this.store = store;
  }
}

const routeMonitor = new RouteMonitor();
export default routeMonitor;

